import './App.css';
import Hero from './Hero/Hero';
import Filter from './Filter/Filter';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import Info from './Info/Info';
import Form from './Form/Form';
import Login from './Login/Login';
import Chat from './Chat/Chat';
import Orders from './Orders/Orders';
import Escrow from './Escrow/Escrow';
import Grievance from './Grievance/Grievance';
import Calculator from './Calculator/Calculator';
import ArTour from './ArTour/ArTour';
import Agent from './Agent/Agent';
import VerifyCustomer from './VerifyCustomer/VerifyCustomer';
import ChatAgent from './ChatAgent/ChatAgent';

function App() {

/* for small an dmedium devices  =>>> resizeing is provided in filter.css file, form.css file , Nav.css file  */

  return (
     <Router>
      <Routes>
      <Route exact path="/" element={<Login />}/>
        <Route path="/hero" element={<Hero />}/>
        <Route path="/filter" element={<Filter />} />
        <Route path="/info" element={<Info />} />
        <Route path="/form" element={<Form />} />
        <Route path="/chat" element={<Chat />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/grievance" element={<Grievance />} />
        <Route path="/escrow" element={<Escrow />} />
        <Route path="/calci" element={<Calculator />} />
        <Route path="/artour" element={<ArTour />} />
        <Route path="/agent" element={<Agent />} />
        <Route path="/verifycustomer" element={<VerifyCustomer />} />
        <Route path="/chatagent" element={<ChatAgent />} />
      </Routes>
    </Router>
  );
}

export default App;
